// @core/api/endpoints/project/restore_project.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProjectResponse,
  RestoreProjectRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Restore archived project
 * Restores a previously archived project to active status. All data including boards, items, and sprints are preserved.
 */
export async function RestoreProject(
  project_id: string,
  data: RestoreProjectRequest,
  options?: RequestOptions
): Promise<ProjectResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/restore`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<ProjectResponse>(requestPath, data, requestOptions);
}
